module.exports = __webpack_public_path__ + "img/6.e0980a5c.png";